<template>
    <Empty
        v-if="filterCount"
        class="py-10"
    >
        <template #title>
            No events available.
        </template>
        <template #subtitle>
            <div>Try clearing your {{ filterCount === 1 ? 'filter' : 'filters' }}.</div>
            <DButton
                class="mt-6"
                theme="secondary"
                @click="clearFilters"
            >
                Clear {{ filterCount === 1 ? 'filter' : 'filters' }}
            </DButton>
        </template>
    </Empty>

    <Empty
        v-else
        class="py-10"
    >
        <template #title>
            No events available
        </template>
        <template #subtitle>
            {{ subtitle }}
        </template>
    </Empty>
</template>
<script setup>
    import { DButton } from '@digistorm/spark'

    defineProps({
        filterCount: Number,
        subtitle: String,
        clearFilters: Function,
    })
</script>
